import React from "react";
import { Divider } from "@mui/material";
import AttachmentViewer from "../AttachmentViewer/AttachmentViewer";
import { useSelector } from "react-redux";
import CorePracticeTags from "../CorePracticeTags/CorePracticeTags";
import CoreSpinner from "../CoreSpinner/CoreSpinner";

const CorePreviewDoc = ({ singleDoc }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  if (!singleDoc) {
    return <CoreSpinner />;
  }

  return (
    <div>
      <h3 className="m-0">{singleDoc?.userName}</h3>
      <div className="flex justify-between items-center">
        <p className="m-0 font-bold" style={{ color: colorPrimary }}>
          {singleDoc?.name}
        </p>
        {singleDoc?.practiceDocuments?.length > 0 && (
          <CorePracticeTags practiceDocuments={singleDoc?.practiceDocuments} />
        )}
      </div>

      <Divider className="p-2" />
      <h3>Anteprima Documento</h3>
      <AttachmentViewer files={singleDoc?.files} />
    </div>
  );
};

export default CorePreviewDoc;
